var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitGraph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2968 5.67188H19.0783C18.69 5.67188 18.3752 5.98667 18.3752 6.37497C18.3752 6.76327 18.69 7.07807 19.0783 7.07807H21.5995L12.7504 15.9271L7.62279 10.7995C7.34825 10.5249 6.90305 10.5249 6.62846 10.7995L0.225308 17.1273C-0.0492747 17.4019 -0.0861639 17.8471 0.188419 18.1217C0.462955 18.3962 0.945046 18.3963 1.21963 18.1217L7.12565 12.2909L12.2533 17.4186C12.5278 17.6932 12.973 17.6932 13.2476 17.4186L22.5938 8.07239V10.5936C22.5938 10.9819 22.9086 11.2967 23.2969 11.2967C23.6852 11.2967 24 10.9819 24 10.5936V6.37521C24.0002 5.9765 23.673 5.67188 23.2968 5.67188Z",
    fill: "#008342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitGraph);
export default __webpack_public_path__ + "static/media/profit-graph.6760a4ef703be47a14b74402e4f22f88.svg";
export { ForwardRef as ReactComponent };